
import { Card, Typography, Box, Grid } from "@mui/material";

const ProductCard = ({ product }) => {
  return (
    <Card
      sx={{
        width: 300,
        height: 240,
        p: 3,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <Typography
            variant="h5"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              mb: 1,
            }}
          >
            {product.name}
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              mb: 2,
              color: "primary.main",
            }}
          >
            {product.category}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              backgroundColor: "error.main",
              color: "white",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
              fontSize: "24px",
            }}
          >
            <Typography variant="subtitle1">Qty</Typography>
            <Typography variant="h5">{product.quantityInStock}</Typography>
          </Box>
        </Grid>
      </Grid>

      <Box>
        <Box display="flex" alignItems="center" mb={1}>
          <Typography
            variant="body1"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              mr: 2,
              fontWeight: "bold",
            }}
          >
            Supplier:
          </Typography>
          <Typography
            variant="body1"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {product.supplier}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" mb={1}>
          <Typography
            variant="body1"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              mr: 2,
              fontWeight: "bold",
            }}
          >
            Location:
          </Typography>
          <Typography
            variant="body1"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {product.warehouseLocation}
          </Typography>
        </Box>
        <Box>
          <Typography variant="subtitle1">Cost</Typography>
          <Typography variant="h5">
            {"\u20B9"}
            {product.costPerUnit.toFixed(2)}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

export default ProductCard;
